import { TimelineTypes } from '../timeline-chart-base/timeline-chart-base.model';
import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { D3Event } from '../charts.model';
import { TimelineData } from '../timeline-chart-base/timeline-chart-base.model';
import { DurationFormatPipe } from '../../pipes/duration-format.pipe';

@Component({
  selector: 'app-timeline-chart-wrapper',
  templateUrl: './timeline-chart-wrapper.component.html',
  styleUrls: ['./timeline-chart-wrapper.component.scss']
})
export class TimelineChartWrapperComponent implements OnInit {
  @Input() data: TimelineData;
  @Input() avtiveRunColor = '#d5eae8';
  @Input() inavtiveRunColor = '#527c9f';
  @Input() activeRunText: string;
  @Input() inactiveRunText: string;
  @Input() strongHitText: string;
  @Input() weakHitText: string;
  @Input() forkliftText: string;
  @Input() hitText: string;
  @Input() durationText: string;
  @ViewChild('chartWrapper') chartWrapper;

  xPosition = 0;
  yPosition = 0;
  showTooltip = false;
  tooltipText: {
    type: 'timeline' | 'point' | any;
    forklift: string;
    when: string;
    desc: string;
  };

  @HostListener('mousemove', ['$event'])
  onMousemove(event: MouseEvent) {
    this.xPosition = event.clientX - 90;
    this.yPosition = this.chartWrapper.nativeElement.getBoundingClientRect().y - this.chartWrapper.nativeElement.offsetHeight / 2;
  }

  constructor(private durationFormat: DurationFormatPipe) {}

  ngOnInit() {}

  positionTooltip() {
    return {
      top: this.yPosition.toString() + 'px',
      left: this.xPosition.toString() + 'px'
    };
  }

  onMouseOver(event: D3Event) {
    const { d } = event;
    this.tooltipText = {
      forklift: event.d.forklift,
      type:
        d.type === TimelineTypes.INACTIVE || d.type === TimelineTypes.ACTIVE
          ? 'timeline'
          : 'point',
      when: '',
      desc: ''
    };
    switch (event.d.type) {
      case TimelineTypes.INACTIVE:
      case TimelineTypes.ACTIVE:
        this.tooltipText.when = d.timeFrom;
        const timeDuration = this.durationFormat
          .transform(d.timeTo - d.timeFrom, 'hh:mm:ss')
          .split(':');
        timeDuration.splice(1, 0, 'h');
        timeDuration.splice(3, 0, 'm');
        this.tooltipText.desc = timeDuration.join('') + 's';
        break;
      case TimelineTypes.WEAK:
      case TimelineTypes.STRONG:
        this.tooltipText.when = d.time;
        this.tooltipText.desc = d.strength;
        break;
      default:
        break;
    }
    this.showTooltip = true;
  }

  onMouseOut(event: D3Event) {
    this.showTooltip = false;
  }
}
